const colours = ["f72585","b5179e","7209b7","560bad","480ca8","3f37c9","0a9396","4361ee","4895ef","4cc9f0"];

const defaultColour = 'ff4800';

const states = new Map([
    ['new', 'f72585'],
    ['active', 'fb8500'],
    ['declined', '333533'],
    ['completed', '9d4edd'],
    ['accepted', colours[4]],
    ['submitted', '25a18e'],
    ['draft', 'fb8500'],
    ['live', '1e96fc'],
])

const getStateColour = state => `#${states.get(state) ?? defaultColour}`;

export default getStateColour;